<template>
	<div v-if="!item.hidden" class="topnav">
		<template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
			<app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
				<el-menu-item :index="onlyOneChild.meta.title" @click="first()" style="">
					<item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="$t(onlyOneChild.meta.title)" />
				</el-menu-item>
			</app-link>
		</template>
		<el-menu-item v-else ref="subMenu" :index="item.meta.title" @click="al(index)" popper-append-to-body>
			<item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="$t(item.meta.title)" />
			<!-- <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)"
			 class="nest-menu" /> -->
		</el-menu-item>
	</div>
</template>
<!-- <template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="$t(onlyOneChild.meta.title)" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="$t(item.meta.title)" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template> -->
<!--<span>{{item.meta.title}}</span>-->
<script>
	import path from 'path'
	import bus from './bus.js'
	import {isExternal} from '@/utils/validate'
	import Item from './Item'
	import AppLink from './Link'
	import FixiOSBug from './FixiOSBug'

	export default {
		name: 'SidebarItem',
		components: {
			Item,
			AppLink
		},
		mixins: [FixiOSBug],
		topname: '首页',
		props: {
			// route object
			item: {
				type: Object,
				required: true
			},
			isNest: {
				type: Boolean,
				default: false
			},
			basePath: {
				type: String,
				default: ''
			},
			index: {
				type: Number,
				default: ''
			}
		},
		data() {
			this.onlyOneChild = null
			return {

			}
		},
		created() {
			var itemall = [this.item];
		},
		computed: {

		},
		methods: {
			hasOneShowingChild(children = [], parent) {
				const showingChildren = children.filter(item => {
					if (item.hidden) {
						return false
					} else {
						// Temp set(will be used if only has one showing child)
						this.onlyOneChild = item
						return true
					}
				})

				// When there is only one child router, the child router is displayed by default
				if (showingChildren.length === 1) {
					return true
				}
				// Show parent if there are no child router to display
				if (showingChildren.length === 0) {
					this.onlyOneChild = { ...parent,
						path: '',
						noShowingChildren: true
					}
					return true
				}
				return false
			},
			resolvePath(routePath) {
				if (isExternal(routePath)) {
					return routePath
				}
				if (isExternal(this.basePath)) {
					return this.basePath
				}
				return path.resolve(this.basePath, routePath)
			},
			al(index) {
				this.topname = index;
				bus.$emit("topname", this.topname);
				let routers = this.$store.getters.permission_routes;	// 获取路由
				let chindrens = routers[index].children;
        let path = this.recurison(chindrens);
        this.$router.push(path);
        this.$store.commit('newTopNav', index);
        // for (var i = 0; i < chindrens.length; i++) {
        //   if (!chindrens[i].hidden) {
        //     if( !chindrens[i].children){
        //       this.$router.push(chindrens[i].path);
        //       this.$store.commit('newTopNav', index);
        //       break;
        //     }else{
        //       for (var j = 0; j < chindrens[i].children.length; i++) {
        //         if (!chindrens[i].children[j].hidden) {
        //           this.$router.push(chindrens[i].children[j].path);
        //           this.$store.commit('newTopNav', index);
        //           return;
        //         }
        //       }
        //     }
        //   }
        // }
			},
      // 递归找到第一个不是隐藏的孩子节点 add by robert at 20210805 19:53
      recurison(childrens){
        for (let i=0;i< childrens.length;i++){
          if (childrens[i].hidden == false && !childrens[i].children){
            return childrens[i].path;
          }else if (childrens[i].hidden || !childrens[i].children) {
            continue;
          }else{
            return this.recurison(childrens[i].children);
          }
        }
      },
			first() {
				this.$store.commit('newTopNav', 0);
				// bus.$emit("topname", this.topname);
			}
		},
		watch: { // 路由监听：监听路由的变化，从而做出相应操作
			$route: {
				immediate: true, // 一旦监听到路由的变化立即执行
				handler(to, from) { // 回调函数，两个参数，to：当前的组件，from：上一个组件
					bus.$emit("topname", to.permission_routes);
				}
			}
		}
	}
</script>
<style>
	.topnav {
		height: 86px;
	}



	.firstitem:focus {
		background-color: white !important;
	}

	.firstitem:hover {
		opacity: 0.5 !important;
	}

	.topnav {
		display: inline-block;
	}
</style>
